import React, {PropTypes} from "react";
import {connect} from "react-redux";
import PersonalInfo from "./Tables/PersonalInfo";
import PersonalInfoForm from "./Tables/PersonalInfoEdit";
import ProfessionalInfo from "./Tables/ProfessionalInfo";
import FinancialInfo from "./Tables/FinancialInfo";
import FinancialInfoEdit from "./Tables/FinanceInfoEdit";
import ContactInfo from "./Tables/ContactInfo";
import ContactInfoEdit from "./Tables/ContactInfoEdit";
import OtherInfo from "./Tables/OtherInfo";
import OtherInfoEdit from "./Tables/OtherInfoEdit";
import axios from "axios";
import moment from "moment";


function modifyDates(employee) {
  let emp = new Object();
  emp = employee;
  if (emp['empDOB'] != null) {
    emp['empDOB'] = new Date(emp['empDOB']);
  }
  let fields = ['empAnniversary', 'spouseDOB', 'child1DOB', 'child2DOB']
  fields.map((node)=> {
    let date = moment(employee[node], "DD-MM-YYYY");
    if (moment(date).isValid()) {
      emp[node] = new Date(date);
    }
  });
  emp["accountNo2"] = emp["accountNo"];
  return emp;

}

class EmployeeSS extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      employee: {},
      initial: {},
      editAccount: "",
      employeeProfessional: {},
      showEdit: this.props.showAll,
      showContact: this.props.showAll,
      showOther: this.props.showAll,
      showFinance: this.props.showAll
    };
    this.personalEdit = this.personalEdit.bind(this);
    this.financeEdit = this.financeEdit.bind(this);
    this.closeFinanceEdit = this.closeFinanceEdit.bind(this);
    this.closePersonalEdit = this.closePersonalEdit.bind(this);
    this.contactEdit = this.contactEdit.bind(this);
    this.closeContactEdit = this.closeContactEdit.bind(this);
    this.otherEdit = this.otherEdit.bind(this);
    this.closeOtherEdit = this.closeOtherEdit.bind(this);
    this.submitContactInfo = this.submitContactInfo.bind(this);
    this.submitOtherInfo = this.submitOtherInfo.bind(this);
    this.submitPersonalInfo = this.submitPersonalInfo.bind(this);
    this.submitFinanceInfo = this.submitFinanceInfo.bind(this);
  }

  submitContactInfo(data) {
    axios.post(process.env.REQ_URL + "/edit/contactJoinerInfo", {data: data}, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
      axios.get(process.env.REQ_URL + "/personal?q=" + this.props.employee.empno, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
        let employee = Object.assign({}, response.data.data);
        employee = modifyDates(employee);

        this.setState({employee: response.data.data, showContact: false, initial: employee})
      }).catch((error) => {
        console.log(error);
      });

    }).catch((error) => {
      console.log(error);
    });
  }

  submitFinanceInfo(data) {
    axios.post(process.env.REQ_URL + "/edit/financeJoinerInfo", {data: data}, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
      axios.get(process.env.REQ_URL + "/personal?q=" + this.props.employee.empno, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
        let employee = Object.assign({}, response.data.data);
        employee = modifyDates(employee);

        this.setState({employee: response.data.data, showFinance: false, initial: employee})
      }).catch((error) => {
        console.log(error);
      });

    }).catch((error) => {
      console.log(error);
    });
  }

  submitOtherInfo(data) {
    let request = Object.assign({}, data);
    let fields = ['spouseDOB', 'child1DOB', 'child2DOB']
    fields.map((node)=> {
      if (request[node] != null)
        request[node] = request[node].toLocaleDateString('en-GB');
    });
    axios.post(process.env.REQ_URL + "/edit/otherJoinerInfo", {data: request}, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
      axios.get(process.env.REQ_URL + "/personal?q=" + this.props.employee.empno, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
        let employee = Object.assign({}, response.data.data);
        employee = modifyDates(employee);

        this.setState({employee: response.data.data, showOther: false, initial: employee})
      }).catch((error) => {
        console.log(error);
      });

    }).catch((error) => {
      console.log(error);
    });
  }

  submitPersonalInfo(data) {
    let request = Object.assign({}, data);

    if (request['empAnniversary'] != null)
      request['empAnniversary'] = request['empAnniversary'].toLocaleDateString('en-GB');
    if (request['empDOB'] != null)
      request['empDOB'] = request['empDOB'].getTime();
    axios.post(process.env.REQ_URL + "/edit/personalJoinerInfo", {data: request}, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
      axios.get(process.env.REQ_URL + "/personal?q=" + this.props.employee.empno, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
        let employee = Object.assign({}, response.data.data);
        employee = modifyDates(employee);

        this.setState({employee: response.data.data, showEdit: false, initial: employee})
      }).catch((error) => {
        console.log(error);
      });

    }).catch((error) => {
      console.log(error);
    });

  }

  componentDidMount() {
    this.props.changeBanner("My Profile");
    axios.get(process.env.REQ_URL + "/personal?q=" + this.props.employee.empno, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
      let employee = Object.assign({}, response.data.data);
      employee = modifyDates(employee);
      this.setState({employee: response.data.data, initial: employee})

    }).catch((error) => {
      console.log(error);
    });
    axios.get(process.env.REQ_URL + "/aboutEmp?q=" + this.props.employee.empno, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {


      this.setState({employeeProfessional: response.data.data})

    }).catch((error) => {
      console.log(error);
    });

  }

  financeEdit() {
    this.setState({showFinance: true})
  }

  closeFinanceEdit() {
    this.setState({showFinance: false});
  }

  contactEdit() {
    this.setState({showContact: true})
  }

  closeContactEdit() {
    this.setState({showContact: false})
  }

  otherEdit() {
    this.setState({showOther: true})
  }

  closeOtherEdit() {
    this.setState({showOther: false})
  }

  personalEdit() {
    this.setState({showEdit: true})
  }

  closePersonalEdit() {
    this.setState({showEdit: false})
  }

  render() {

    const initialValues = {
      initialValues: this.state.initial,
    };
    console.log(this.props.employee);

    return (
      <div >
        <div style={{display: !this.props.showAll ? 'none' : null}}>
          <div className="col-md-10">
            &nbsp;
          </div>
          <div className="col-md-2">
            <button
              onClick={()=> {
                let data = this.state.initial.empId;
                axios.post(process.env.REQ_URL + "/onBoarding/completeJoiningForm", {data: data}, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
                  window.location.reload();
                }).catch((error)=> {
                  console.log(error);
                });

              }}
              disabled={this.state.showEdit || this.state.showContact || this.state.showFinance || this.state.showOther}
              className="btn btn-lg btn-success">Completed&nbsp;<i className="glyphicon glyphicon-arrow-right"></i>
            </button>
          </div>
        </div>


        {this.state.showEdit && this.state.initial.empId != undefined ?
          <PersonalInfoForm
            submitHandler={this.submitPersonalInfo}
            close={this.closePersonalEdit}
            {...initialValues}/> :
          <PersonalInfo
            employee={this.state.employee}
            edit={this.personalEdit}
          />}

        <div style={{margin: '20'}}>&nbsp;</div>

        <ProfessionalInfo
          employee={this.state.employeeProfessional}
        />
        <div style={{margin: '20'}}>&nbsp;</div>
        {this.state.showFinance && this.state.initial.empId != undefined ?
          <FinancialInfoEdit
            submitHandler={this.submitFinanceInfo}
            employee={this.state.employee}
            close={this.closeFinanceEdit}
            editAccount={this.props.editAccount}
            {...initialValues}
          /> :
          <FinancialInfo
            edit={this.financeEdit}
            employee={this.state.employee}
          />}
        <div style={{margin: '20'}}>&nbsp;</div>
        {this.state.showContact && this.state.initial.empId != undefined ?
          <ContactInfoEdit
            submitHandler={this.submitContactInfo}
            close={this.closeContactEdit} {...initialValues}/> :
          <ContactInfo

            employee={this.state.employee}
            edit={this.contactEdit}/>}


        <div style={{margin: '20'}}>&nbsp;</div>
        {this.state.showOther && this.state.initial.empId != undefined ?
          <OtherInfoEdit
            submitHandler={this.submitOtherInfo}
            close={this.closeOtherEdit}
            {...initialValues}/> :
          <OtherInfo
            employee={this.state.employee}
            edit={this.otherEdit}/>}

      </div>
    );
  }

}

EmployeeSS.propTypes = {};

function mapStateToProps(state, ownState) {
  return {};

}

export default connect(mapStateToProps)(EmployeeSS);




/** WEBPACK FOOTER **
 ** ./src/components/joiningForm/EmployeeSS.js
 **/